import { Letter } from './types';

export const HEADER_HEIGHT = 88;
export const ALPHABET_HEIGHT = 26;
export const LETTERS_GAP = 26;

export const LETTERS: Letter[] = [
  {
    label: 'A',
    brands: [],
  },
  {
    label: 'B',
    brands: [],
  },
  {
    label: 'C',
    brands: [],
  },
  {
    label: 'D',
    brands: [],
  },
  {
    label: 'E',
    brands: [],
  },
  {
    label: 'F',
    brands: [],
  },
  {
    label: 'G',
    brands: [],
  },
  {
    label: 'H',
    brands: [],
  },
  {
    label: 'I',
    brands: [],
  },
  {
    label: 'J',
    brands: [],
  },
  {
    label: 'K',
    brands: [],
  },
  {
    label: 'L',
    brands: [],
  },
  {
    label: 'M',
    brands: [],
  },
  {
    label: 'N',
    brands: [],
  },
  {
    label: 'O',
    brands: [],
  },
  {
    label: 'P',
    brands: [],
  },
  {
    label: 'Q',
    brands: [],
  },
  {
    label: 'R',
    brands: [],
  },
  {
    label: 'S',
    brands: [],
  },
  {
    label: 'T',
    brands: [],
  },
  {
    label: 'U',
    brands: [],
  },
  {
    label: 'V',
    brands: [],
  },
  {
    label: 'W',
    brands: [],
  },
  {
    label: 'X',
    brands: [],
  },
  {
    label: 'Y',
    brands: [],
  },
  {
    label: 'Z',
    brands: [],
  },
  {
    label: 'RU',
    brands: [],
  },
];
